import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'Marcelo',
  province: 'Buenos Aires'
}, {
  name: 'Javier',
  province: 'Córdoba'
}, {
  name: 'Diego',
  province: 'Santa Fe'
}, {
  name: 'Rubén',
  province: 'Mendoza'
}, {
  name: 'Gastón',
  province: 'Tucumán'
}, {
  name: 'Pablo',
  province: 'Entre Ríos'
}, {
  name: 'Hernán',
  province: 'Salta'
}];
export function SocialProofPopup() {
  const [currentBuyer, setCurrentBuyer] = useState<{
    name: string;
    province: string;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then interval
    const interval = setInterval(() => {
      showPopup();
    }, 15000); // Every 15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-428">
      {isVisible && currentBuyer && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-center gap-4 z-50 max-w-[300px]" data-id="element-429">
          <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-430">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-431" />
          </div>
          <div data-id="element-432">
            <p className="text-sm font-bold text-gray-800 leading-tight" data-id="element-433">
              {currentBuyer.name} de {currentBuyer.province}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-434">
              acaba de comprar el Mega Pack
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}